export default function NeedGeAndLt({ sampleLink }: { sampleLink: string }) {
  return (
    <div style={{ padding: "2em" }}>
      You need to enter ge and lt as url params! <br />
      For example:
      <a href={sampleLink}>
        {" Link with shift start and end time in Epoch time"}
      </a>
    </div>
  );
}
